/**
 * Whether a search is worth storing on the user's search list. Filters alone
 * are not: the Kilder table always has a source selected, and the search modal
 * can be closed on a bare filter, so either would otherwise store a search on
 * every visit. Global search and the Kilder page share this rule.
 */
export const hasSearchContent = (
  searchTerm: string | undefined,
  searchTags: string[] | undefined
): boolean =>
  (searchTerm ?? "").trim() !== "" || trimmedSearchTags(searchTags).length > 0;

/** A search's tags without the blanks a stray separator leaves behind. */
export const trimmedSearchTags = (searchTags: string[] | undefined): string[] =>
  (searchTags ?? []).map((tag) => tag.trim()).filter(Boolean);
